import { PRESET_EXAMPLES } from "../constants";
import HelpTooltip from "./HelpTooltip";

const THEME_GROUPS = [
  {
    id: "headerChat",
    label: "Header & Chat",
    fields: [
      { key: "chatprimaryText", label: "Text Color" },
      { key: "chatprimaryBg", label: "Background Color" },
    ],
  },
  {
    id: "submenu",
    label: "Menu Options",
    fields: [
      { key: "submenuText", label: "Text Color" },
      { key: "submenuBg", label: "Background Color" },
      { key: "submenuHoverBg", label: "Highlight Color" },
    ],
  },
  {
    id: "botMessage",
    label: "Chatbot Replies",
    fields: [
      { key: "botText", label: "Text Color" },
      { key: "botBg", label: "Background Color" },
    ],
  },
  {
    id: "chatBackground",
    label: "Chat Window Background",
    fields: [{ key: "chatBgColor", label: "Background Color" }],
  },
  {
    id: "logoBackground",
    label: "Logo Background",
    fields: [{ key: "logoBgColor", label: "Background Color" }],
  },
];

const AppearanceSettings = ({ config, onChange, onApplyPreset }: any) => {
  const chatTheme = config.chatTheme || {};
  const handleThemeChange = (key, value) => {
    onChange("chatTheme", { ...chatTheme, [key]: value });
  };

  const applyPreset = (preset) => {
    if (onApplyPreset) {
      if (preset.chatTheme) {
        onApplyPreset(preset.chatTheme);
      } else if (preset.colors) {
        onApplyPreset(preset.colors);
      }
    }
  };

  return (
    <div className="wc-section">
      {/* Presets */}
      <div className="wc-section-header">
        <div>
          <h5 className="wc-section-title mb-0">
            <i className="bi bi-bookmark-star me-2" />
            Quick Themes
            <HelpTooltip text="Pick a ready-made colour theme to instantly restyle your chatbot. You can fine-tune individual colours below." />
          </h5>
        </div>
      </div>
      <p className="text-muted mb-3" style={{ fontSize: "13px" }}>
        Pick a theme to instantly update colours, then adjust individual colours below if needed
      </p>

      <div className="row g-2 mb-3">
        {PRESET_EXAMPLES.map((preset) => (
          <div key={preset.id} className="col-6">
            <div className="border rounded p-2 d-flex flex-column align-items-center text-center" style={{ cursor: "pointer" }} onClick={() => applyPreset(preset)}>
              <div className="d-flex gap-1 mb-1">
                <span style={{ width: 14, height: 14, borderRadius: "50%", backgroundColor: preset.chatTheme?.chatprimaryBg || preset.colors?.primary || "#9b4598", display: "inline-block" }} />
                <span style={{ width: 14, height: 14, borderRadius: "50%", backgroundColor: preset.chatTheme?.submenuHoverBg || preset.colors?.secondary || "#e1bee7", display: "inline-block" }} />
                <span style={{ width: 14, height: 14, borderRadius: "50%", backgroundColor: preset.chatTheme?.chatBgColor || preset.colors?.bg || "#f5f5f5", border: "1px solid #ddd", display: "inline-block" }} />
              </div>
              <small className="fw-medium" style={{ fontSize: "11px" }}>{preset.name}</small>
            </div>
          </div>
        ))}
      </div>

      {/* Theme Customize */}
      <div className="wc-section-header">
        <div>
          <h5 className="wc-section-title">
            <i className="bi bi-palette2 me-2" />
            Fine-Tune Colours
            <HelpTooltip text="Click any colour swatch to open a colour picker. Changes are reflected in the chatbot preview so you can see exactly how it will look." />
          </h5>
        </div>
      </div>

      <div className="wc-theme-customize">
        {THEME_GROUPS.map((group) => (
          <div key={group.id} className="wc-theme-section">
            <h6 className="wc-theme-section-title">{group.label}</h6>
            {group.fields.map((field) => (
              <div key={field.key} className="wc-theme-field-row">
                <span className="wc-theme-field-label">{field.label}</span>
                <label className="wc-theme-pill-swatch">
                  <input
                    type="color"
                    value={chatTheme[field.key] || "#000000"}
                    onChange={(e) => handleThemeChange(field.key, e.target.value)}
                  />
                  <span
                    className="wc-theme-pill"
                    style={{ backgroundColor: chatTheme[field.key] || "#000000" }}
                  />
                </label>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppearanceSettings;
